import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

// Custom Styles
import "./customNav.styles.scss";

// Assets
import BusinessLogo from "../../../assets/img/logo.jpg";
import EventsIcon from "../../../assets/img/events-icon--blue.svg";
import UserIcon from "../../../assets/img/user-icon--blue.svg";

function CustomNav() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);
  const handleLinkClick = () => {
    if (window.innerWidth < 992) {
      setExpanded(false);
    }
  };
  return (
    <Navbar
      expanded={expanded}
      onToggle={handleToggle}
      expand="lg"
      className="custom-nav"
    >
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <img src={BusinessLogo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              className={currentPath === "/" ? "active" : ""}
              onClick={handleLinkClick}
            >
              <span>Inicio</span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/acerca-de"
              className={currentPath === "/test" ? "active" : ""}
              onClick={handleLinkClick}
            >
              Quiénes somos
            </Nav.Link>
            <NavDropdown title="Oferta Educativa" id="education-nav-dropdown">
              <NavDropdown.Item
                as={Link}
                to="/oferta-educativa"
                onClick={handleLinkClick}
              >
                Licenciaturas
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://dgesum.sep.gob.mx/planes2022"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                Cursos de Estudios Nacionales
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://dgesum.sep.gob.mx/planes2018"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                Planes de Estudio 2018
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://www.ensfa.edu.mx/_files/ugd/16de79_19be7ed1cd22445d8574f22b9d6a965e.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                Convocatoria 2024-2025
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link
              as={Link}
              to="/servicios-institucionales"
              onClick={handleLinkClick}
            >
              Servicios Institucionales
            </Nav.Link>
            <NavDropdown title="Posgrado" id="posgrado-nav-dropdown">
              <NavDropdown.Item
                as={Link}
                to="/maestrias"
                onClick={handleLinkClick}
              >
                Posgrado
              </NavDropdown.Item>
              {/* <NavDropdown.Item
                href="https://www.ensfa.edu.mx/_files/ugd/16de79_fc6cbec2857e46068e9634faed6f7cd7.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                Malla Curricular
              </NavDropdown.Item> */}
              <NavDropdown.Item
                href="https://www.ensfa.edu.mx/_files/ugd/16de79_ff8d5d615aee475faeb9a096b0a72728.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                Perfil de ingreso-egreso
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link
              as={Link}
              to="/investigacion-e-innovacion-educativa"
              onClick={handleLinkClick}
            >
              Investigación e Innovación Educativa
            </Nav.Link>
            <Nav.Link as={Link} to="/contacto" onClick={handleLinkClick}>
              Contacto
            </Nav.Link>
            <div className="d-flex">
              <Nav.Link as={Link} to="/eventos" onClick={handleLinkClick}>
                <img src={EventsIcon} alt="" />
              </Nav.Link>
              {/* <Nav.Link as={Link} to="/test" onClick={handleLinkClick}>
                <img src={UserIcon} alt="" />
              </Nav.Link> */}
              <NavDropdown
                title={<img src={UserIcon} alt="Accesos" />}
                id="access-nav-dropdown"
                className="access-nav-dropdown"
              >
                <NavDropdown.Item
                  href="https://intell-soft1.com/alumnos-ensfa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLinkClick}
                >
                  Acceso alumnos
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://intell-soft1.com/ensfa/index.php"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLinkClick}
                >
                  Acceso Docentes
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://www.bibliotk.mx/login/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLinkClick}
                >
                  Biblioteca Virtual ENSFA
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNav;
